export default __webpack_public_path__ + "static/design-concept-image-e119d2b2570d3b0f5c54f3e97fe6a46b.png";